var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import { sanitizeString } from '@/support/String';
import BookmarksDialog from '@/components/bookmarks/BookmarksDialog/BookmarksDialog';
import { Model as AModel } from '@/models/Model';
let PageHeader = class PageHeader extends Vue {
    constructor() {
        // #endregion
        super(...arguments);
        // #endregion
        // #region Class properties
        this.isShowingBookmarkDialog = false;
        this.currentPath = '';
        this.renameValue = '';
        this.isRenaming = false;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #region Getters & Setters
    get renameKey() {
        let nameKey = '';
        if (this.model) {
            Object.entries(this.model).map(([key, value]) => {
                if (value === this.pageTitle) {
                    nameKey = key;
                }
            });
        }
        return nameKey;
    }
    // #region Lifecycle Hooks / Init
    mounted() {
        this.initialize();
    }
    initialize() {
        if (!this.model) {
            return;
        }
        this.renameValue = this.pageTitle;
    }
    // #endregion
    // #region Class methods
    onCreateBookmark() {
        this.currentPath = window.location.href.replace(window.location.origin, '');
        this.isShowingBookmarkDialog = true;
    }
    onCloseDialog() {
        this.isShowingBookmarkDialog = false;
    }
    handleRenameClick() {
        this.isRenaming ? this.cancelIsRenaming() : this.setIsRenaming();
    }
    setIsRenaming() {
        this.isRenaming = true;
        this.$nextTick(() => {
            this.$refs.renameInput.focus();
        });
    }
    cancelIsRenaming() {
        this.isRenaming = false;
    }
    sanitizeString(value) {
        if (value === 'Algemeen') {
            return this.$tc('General');
        }
        return sanitizeString(value);
    }
    // #endregion
    // #region Async methods
    async renameModel() {
        if (!this.model || !this.renameKey) {
            this.cancelIsRenaming();
            return;
        }
        try {
            await this.model.update({ [this.renameKey]: this.renameValue });
            this.$emit('modelRenamed');
            this.cancelIsRenaming();
        }
        catch (error) {
            //
        }
    }
};
__decorate([
    Model('breadcrumbs'),
    __metadata("design:type", Array)
], PageHeader.prototype, "breadcrumbs", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], PageHeader.prototype, "pageTitle", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], PageHeader.prototype, "avatar", void 0);
__decorate([
    Prop({ required: false }),
    __metadata("design:type", typeof (_a = typeof AModel !== "undefined" && AModel) === "function" ? _a : Object)
], PageHeader.prototype, "model", void 0);
__decorate([
    Prop({ required: false, default: true }),
    __metadata("design:type", Boolean)
], PageHeader.prototype, "canFavourite", void 0);
PageHeader = __decorate([
    Component({
        components: {
            'mi-breadcrumbs': Breadcrumbs,
            BookmarksDialog,
        },
    })
], PageHeader);
export default PageHeader;
